import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewFieldsComponent } from './view-fields.component';
import { MaterialModule } from 'src/app/shared/material/material.module';



@NgModule({
  declarations: [
    ViewFieldsComponent
  ],
  imports: [
    CommonModule,
    MaterialModule
  ]
})
export class ViewFieldsModule { }
